import React, { useState } from "react";
import { Tabs as Abas, Tab, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";
import TabWms from "./TabWms";
import TabEmpresa from "./TabEmpresa";

function TabsWms({
  touched,
  values,
  errors,
  handleChange,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana
}) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Container>
      <StyledTabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <StyledTabList>
          <StyledTab>Empresa</StyledTab>
          <StyledTab>WMS</StyledTab>
        </StyledTabList>
        <StyledTabPanel>
          <TabEmpresa
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            onTestConnect={onTestConnect}
            onTestConnectHana={onTestConnectHana}
            connected={connected}
            connectedHana={connectedHana}
            isLoading={isLoading}
            isLoadingHana={isLoadingHana}
          />
        </StyledTabPanel>
        <StyledTabPanel>
          <TabWms
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
          />
        </StyledTabPanel>
      </StyledTabs>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  font-family: 'Mulish', sans-serif;
`;

const StyledTabs = styled(Abas)`
  .react-tabs__tab-list {
    border-bottom: none;
    margin: 0 0 24px;
    padding: 0;
    display: flex;
    gap: 8px;
  }
`;

const StyledTabList = styled(TabList)`
  border-bottom: 2px solid #e2e8f0 !important;
  margin: 0 0 24px !important;
  padding: 0 !important;
  display: flex !important;
  gap: 8px !important;
  list-style: none !important;
`;

const StyledTab = styled(Tab)`
  padding: 12px 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-family: 'Mulish', sans-serif;
  outline: none;
  list-style: none;

  &:hover {
    color: #84cc16;
    background: rgba(132, 204, 22, 0.05);
    border-radius: 8px 8px 0 0;
  }

  &.react-tabs__tab--selected {
    color: #84cc16;
    border-bottom-color: #84cc16;
    background: rgba(132, 204, 22, 0.05);
    border-radius: 8px 8px 0 0;
  }

  &:focus {
    box-shadow: none;
  }
`;

const StyledTabPanel = styled(TabPanel)`
  display: none;

  &.react-tabs__tab-panel--selected {
    display: block;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default TabsWms;
